import React, { useContext } from 'react'
import { Navigate, useParams } from 'react-router'
import ReviewWorkFormScene from '@Scenes/WorkScenes/ReviewWorkFormScene'
import ViewWorkHeader from '@Components/ViewWork/Headers/ViewWorkHeader'
import { StoresContext } from '@App/contexts'
import Navigation from '@App/navigation'
import { isValidWorkType, WorkType } from '@Components/ViewWork/work-type'
import { PARAM } from '@App/navigation/param'

interface EditFormSceneWrapperProps {
    workType?: WorkType
}

const EditFormSceneWrapper = (props: EditFormSceneWrapperProps) => {
    let workType: WorkType
    if (props.workType) {
        workType = props.workType
    } else {
        const params = useParams<typeof PARAM>()
        const typeWork = params.typeWork || 'bulk'
        if (isValidWorkType(typeWork)) {
            workType = typeWork as WorkType
        } else {
            throw new Error('Invalid Work Type ' + typeWork)
        }
    }
    const { workStore, rightsholderStore } = useContext(StoresContext)
    const workDraftFromLocal = workStore.workDraftLocal
    if (!workDraftFromLocal) {
        return <Navigate to={Navigation.rightholder.catalog.root(rightsholderStore.currentRightsholderId)} />
    }

    return (
        <>
            <ViewWorkHeader work={workDraftFromLocal} />
            <ReviewWorkFormScene workType={workType} />
        </>
    )
}

export default EditFormSceneWrapper
